'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _isotopeLayout = require('isotope-layout');

var _isotopeLayout2 = _interopRequireDefault(_isotopeLayout);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

var _themeCurrency = require('@shopify/theme-currency');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

require('../sections/swiper');

require('../sections/blog');

require('../sections/quickAdd');

require('../sections/greatest-gift');

require('../sections/collectionFilter');

var _bundle = require('swiper/bundle');

var _bundle2 = _interopRequireDefault(_bundle);

require('swiper/swiper-bundle.css');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathName = window.location.pathname;

// import Swiper

// import Swiper styles


// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

var isMobile = false; //initiate as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  (0, _jquery2.default)('.mobile-delete').remove();
}

(0, _jquery2.default)(document).on('click', '.burger', function () {
  (0, _jquery2.default)('body').toggleClass('open-mobile-nav');
});

(0, _jquery2.default)(document).on('click', '.close-nav, .nav-overlay', function (e) {
  (0, _jquery2.default)('body').toggleClass('open-mobile-nav');
});

(0, _jquery2.default)(document).on('click', '.icon-close-announcement', function () {
  (0, _jquery2.default)('.announcement-bar').addClass('hide');
  (0, _jquery2.default)('body').removeClass('announcement-bar-enabled');
});

(0, _jquery2.default)(document).on('click', '.open-search', function (e) {

  if (!(0, _jquery2.default)(this).hasClass('scrolled')) {
    e.preventDefault();
    (0, _jquery2.default)('.search-trigger').addClass('active');
  }
});

(0, _jquery2.default)(document).on('click', '.close-search', function (e) {
  e.preventDefault();

  (0, _jquery2.default)('.search-trigger').removeClass('active');
});

(0, _jquery2.default)(document).on('click', '.careers-select', function (e) {
  e.preventDefault();
  var type = (0, _jquery2.default)(this).attr('data-careers');
  (0, _jquery2.default)('.careers-select').removeClass('active');
  (0, _jquery2.default)('.career-post').addClass('hide');
  (0, _jquery2.default)('.' + type).removeClass('hide');
  (0, _jquery2.default)(this).addClass('active');
});

// @start popup
var $thePopup = (0, _jquery2.default)('.popup');
var popupCookie = 'popup_display';
var popupDelay = $thePopup.length > 0 ? parseInt($thePopup.attr('data-delay')) : false;
var popupRemember = $thePopup.length > 0 ? parseInt($thePopup.attr('data-remember')) : false;

$thePopup.on('shown.bs.modal', function () {
  $thePopup.find('input[type="email"]').trigger('focus');
});

if ($thePopup.length > 0) {
  if ('undefined' === typeof _jsCookie2.default.get(popupCookie) || 'n' != _jsCookie2.default.get(popupCookie)) {
    setTimeout(function () {
      $thePopup.fadeIn();
    }, popupDelay);
    (0, _jquery2.default)(document).on('click', '.close-modal', function () {
      $thePopup.fadeOut();

      _jsCookie2.default.set(popupCookie, 'n', {
        expires: popupRemember
      });
    });
  }
}
// @end popup

/* ---------------------------------------------
  Sticky Nav on Scroll
  ------------------------------------------------ */
(0, _jquery2.default)(window).on('scroll', function (e) {
  e.preventDefault();
  stickyNav();
});

stickyNav();

function stickyNav() {

  if ((0, _jquery2.default)(window).scrollTop() > 100) {
    (0, _jquery2.default)('body').addClass('scrolled');
    (0, _jquery2.default)('.open-search').addClass('scrolled');
    (0, _jquery2.default)('.search-trigger').removeClass('active');
  } else {
    (0, _jquery2.default)('body').removeClass('scrolled');
    (0, _jquery2.default)('.open-search').removeClass('scrolled');
  }
}

// Apply a specific class to the html element for browser support of cookies.
if ((0, _themeCart.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

// // @start Hero image Swiper
// const swiperSection = new Swiper('.full_width_swiper .swiper-container', {
//   autoHeight: true,
//   spaceBetween: 50,
//   keyboard: {
//     enabled: true,
//     onlyInViewport: false,
//   },
//   loop: true,
//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true

//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   breakpoints: {
//       // when window width is >= 640px
//       768: {
//         effect: 'fade',
//         fadeEffect: {
//           crossFade: true
//         },
//         spaceBetween: 0
//       }
//     }
// });


// // @start Hero image Swiper
// const productSwiper = new Swiper('.product-image-swiper.swiper-container', {

//   keyboard: {
//     enabled: true,
//     onlyInViewport: false,
//   },

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true

//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   spaceBetween: 50
// });
// // @end Hero image Swiper

// // @start Hero image Swiper
// // const swiperSectionText = new Swiper('.section_swiper-text .swiper-container', {
// //
// //   autoHeight: true,
// //   effect: 'fade',
// //   fadeEffect: {
// //     crossFade: true
// //   },
// //   observer: true,
// //   observeSlideChildren: true,
// //   observeParents: true,
// //
// //   keyboard: {
// //     enabled: true,
// //     onlyInViewport: false,
// //   },
// //
// //   loop: true,
// //
// //   // If we need pagination
// //   pagination: {
// //     el: '.swiper-pagination',
// //   }
// //
// // });
// // @end Hero image Swiper


// // var settings = {
// //
// //       navigation: {
// //         nextEl: '.swiper-button-next',
// //         prevEl: '.swiper-button-prev',
// //       },
// //       observer: true,
// //       observeParents: true,
// //       observeSlideChildren: true,
// //       speed: 400,
// //       allowTouchMove: true,
// //       setWrapperSize: true,
// //       loop: false,
// //       autoHeight: true,
// //        effect: 'fade',
// //        fadeEffect: {
// //          crossFade: true
// //        },
// //        pagination: {
// //          el: '.swiper-pagination',
// //        }
// //   }
// //
// //   var costumeSwiper = new Swiper('.section_swiper-text .swiper-container', settings);


// // @start Hero image Swiper
// const announcement = new Swiper('.announcement-bar .swiper-container-announcement-bar', {

//   autoHeight: true,
//   effect: 'fade',
//   fadeEffect: {
//     crossFade: true
//   },

//   keyboard: {
//     enabled: true,
//     onlyInViewport: false,
//   },
//   autoplay: true,
//   loop: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   }
// });
// // @end Hero image Swiper

// // @start Hero image Swiper
// const imgTxtSwiper = new Swiper('.image-text-slide-container .swiper-container', {

//   autoHeight: true,
//   effect: 'fade',
//   fadeEffect: {
//     crossFade: true
//   },

//   keyboard: {
//     enabled: true,
//     onlyInViewport: false,
//   },

//   loop: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

// });
// // @end Hero image Swiper


// // @start Hero image Swiper
//   const prodMethods = new Swiper('.product_method .swiper-container', {

//     autoHeight: true,
//     loop: true,
//     // If we need pagination
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true
//     },
//     spaceBetween: 20,

//     observer: true,
//     observeSlideChildren: true,
//     observeParents: true,
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//     breakpoints: {
//         // when window width is >= 640px
//         768: {

//           spaceBetween: 40
//         }
//       }
//   });
// // @end Hero image Swiper


// @start Accordion

(0, _jquery2.default)(document).on('click', '.product_info_selection--option.type-select', function (e) {
  e.preventDefault();

  var type = (0, _jquery2.default)(this).attr('data-type');

  (0, _jquery2.default)('.type-select').removeClass('active');
  (0, _jquery2.default)(this).addClass('active');

  (0, _jquery2.default)('.more-info').addClass('hide');

  (0, _jquery2.default)('.type-' + type).removeClass('hide');
});

// @end Accordion


// @start Accordion

(0, _jquery2.default)(document).on('click', '.accordion--title', function () {
  (0, _jquery2.default)(this).toggleClass('active');
  if ((0, _jquery2.default)(this).hasClass('active')) {
    (0, _jquery2.default)(this).next().slideDown('fast');
  } else {
    (0, _jquery2.default)(this).next().slideUp('fast');
  }
});

// @end Accordion


(0, _jquery2.default)(document).ready(function () {

  if ((0, _jquery2.default)('.pagination .next')) {
    (0, _jquery2.default)('.pagination .next a').html('>');
  }

  if ((0, _jquery2.default)('.pagination .prev')) {
    (0, _jquery2.default)('.pagination .prev a').html('<');
  }
});

// @start Locations Store Details
var isActive = false;

(0, _jquery2.default)(document).on('click', '.open-store-details', function (e) {
  e.preventDefault();
  toggleLocationDetails(this);
});

(0, _jquery2.default)(document).on('click', '.store_details--icon-close', function () {
  (0, _jquery2.default)('.store_details').fadeOut();
  (0, _jquery2.default)('.open-store-details').html('STORE DETAILS');
});

function toggleLocationDetails(that) {
  var parent = (0, _jquery2.default)(that).closest('.location');
  var storeDetails = (0, _jquery2.default)(parent).find('.store_details');
  isActive = isActive ? false : true;
  isActive ? (0, _jquery2.default)(that).html('CLOSE') : (0, _jquery2.default)(that).html('STORE DETAILS');
  (0, _jquery2.default)(storeDetails).fadeToggle("fast");
}

// @end Locations Store Details


// @start Collection Sort By

(0, _jquery2.default)(document).on('click', '.sort_by--trigger', function (e) {
  (0, _jquery2.default)('.sort_by--ul').toggleClass('active');
  (0, _jquery2.default)('.sort_by--trigger .arrow-down').toggleClass('active');
});

(0, _jquery2.default)(".sort_by").hover(function () {
  (0, _jquery2.default)('.sort_by--ul').addClass('active');
  (0, _jquery2.default)('.sort_by--trigger .arrow-down').addClass('active');
}, function () {
  (0, _jquery2.default)('.sort_by--ul').removeClass('active');
  (0, _jquery2.default)('.sort_by--trigger .arrow-down').removeClass('active');
});

// @end Collection Sort By

(0, _jquery2.default)(document).on('click', '.mobile-filter-trigger', function (e) {
  (0, _jquery2.default)('.collection-filter--main-li.non-active').slideToggle();
  (0, _jquery2.default)('.collection-filter--readout-container').toggle('show');
  (0, _jquery2.default)('.collection-filter--main-li .apply.show-on-mobile').toggleClass('hide');
});

// @start Dropdown


(0, _jquery2.default)(document).on('click', '.dropdown-trigger', function (e) {

  if ((0, _jquery2.default)(e.target).hasClass('link-with-dropdown')) {
    e.preventDefault();
    var dropdown = (0, _jquery2.default)(this).find('.dropdown-ul');
    var arrow = (0, _jquery2.default)(this).find('.arrow-down');
    (0, _jquery2.default)(dropdown).slideToggle("fast");
    (0, _jquery2.default)(arrow).toggleClass('rotate');
  }
});

(0, _jquery2.default)(document).on('click', '.dropdown-trigger', function (e) {

  if ((0, _jquery2.default)(e.target).hasClass('desktop-link-with-dropdown')) {
    // e.preventDefault();

    //   if($(this).hasClass('active')) {
    //     $(this).removeClass('active');
    //   } else {
    //     $('.dropdown-trigger').removeClass('active');
    //     $(this).addClass('active');
    //   }
  }
});

(0, _jquery2.default)(".dropdown-trigger").on({
  // mouseenter: function () {
  //     //stuff to do on mouse enter
  //     $(this).addClass('active');
  // },
  // mouseleave: function () {
  //     //stuff to do on mouse leave
  //     $(this).removeClass('active');
  //
  //     setTimeout(function() {
  //
  //     }, 100);
  //
  // }
});

// @end Dropdown